import React from "react";
export const TextElement = data => (
  <div className={`pt-1 ${data?.className || ""}`}>
    <p>{data?.value}</p>
  </div>
);
